var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-dialog"},[(!this.isMobile())?_c('DesktopLocker'):_vm._e(),(this.isMobile())?_c('MobileLocker'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }